// import React, { useEffect } from "react";
// import img from "../image/clients.jpg";
import img1 from "../image/Image _ Page/Home_page/Explore Our Work.jpg";
import img2 from "../image/Image _ Page/Home_page/Securing Your Future.jpg";
import img3 from "../image/Image _ Page/Home_page/Book Your Call.jpg";
import img4 from "../image/Image _ Page/Home_page/our customers.jpg";
import img5 from "../image/Image _ Page/Home_page/Vision.jpg";
import img6 from "../image/Image _ Page/Home_page/Mission.jpg";
// import sb1 from "../image/Image _ Page/Home_page/Modern server room or network operations center.jpeg";
// import sb2 from "../image/Image _ Page/Home_page/Network diagram or security operations center.jpeg";
// import sb3 from "../image/Image _ Page/Home_page/Cloud computing interface or data center visualization.jpeg";
// import sb4 from "../image/Image _ Page/Home_page/Technician working on-site or remote support interface.jpeg";
import { Link } from "react-router-dom";
import SliderPage from "../Components/slider";
import ServiceSlider from "../Components/serviceslide";
import "../Components/style/homepage.css";
import CustSliderPage from "../Components/customerslider";
import React, { useState } from 'react';

// Required imports at the top of your actual file:
//   import React, { useState, useEffect } from "react";
//   import { Link } from "react-router-dom";
// NOTE: No Navbar import here — your existing Header.jsx (rendered globally in App.js)
// already provides site-wide navigation, so this file doesn't render its own.

// ---- Shared icon paths (reused across hero badges + service cards) ----
const ICONS = {
  networkSecurity: (
    <path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z" />
  ),
  cloud: (
    <path d="M17.5 19H9a5 5 0 1 1 1.3-9.8A6 6 0 0 1 22 12a4 4 0 0 1-4.5 7z" />
  ),
  datacentre: (
    <>
      <rect x="3" y="3" width="18" height="7" rx="1.5" />
      <rect x="3" y="14" width="18" height="7" rx="1.5" />
      <circle cx="7" cy="6.5" r="0.8" fill="currentColor" stroke="none" />
      <circle cx="7" cy="17.5" r="0.8" fill="currentColor" stroke="none" />
    </>
  ),
  collaboration: (
    <>
      <circle cx="7" cy="7" r="3" />
      <circle cx="17" cy="7" r="3" />
      <path d="M3.5 21c0-3 1.5-5 3.5-5s3.5 2 3.5 5" />
      <path d="M13.5 21c0-3 1.5-5 3.5-5s3.5 2 3.5 5" />
    </>
  ),
  automation: (
    <>
      <path d="M3 17l6-6 4 4 8-8" />
      <path d="M15 6h6v6" />
    </>
  ),
  managed: (
    <>
      <circle cx="12" cy="8" r="3.2" />
      <path d="M4.5 20c0-4 3.4-6.5 7.5-6.5s7.5 2.5 7.5 6.5" />
    </>
  ),
  target: (
    <>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="12" cy="12" r="0.5" fill="currentColor" />
    </>
  ),
  eye: (
    <>
      <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  people: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M2 20c0-3.5 3-6 7-6s7 2.5 7 6" />
      <circle cx="17" cy="9" r="2.4" />
      <path d="M16 20c.3-2.6 1.6-4.4 3.5-5.2" />
    </>
  ),
  bulb: (
    <>
      <path d="M9 18h6" />
      <path d="M10 22h4" />
      <path d="M12 2a6 6 0 0 0-4 10.5c.6.6 1 1.3 1 2.5h6c0-1.2.4-1.9 1-2.5A6 6 0 0 0 12 2z" />
    </>
  ),
  shieldCheck: (
    <>
      <path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z" />
      <path d="M9 12l2 2 4-4" />
    </>
  ),
  headset: (
    <>
      <path d="M4 13a8 8 0 0 1 16 0" />
      <rect x="2.5" y="13" width="4" height="6" rx="1.5" />
      <rect x="17.5" y="13" width="4" height="6" rx="1.5" />
    </>
  ),
  trendUp: (
    <>
      <path d="M3 17l6-6 4 4 8-8" />
      <path d="M15 6h6v6" />
    </>
  ),
};

function Icon({ path, size = 22, color = "#2563EB" }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      {path}
    </svg>
  );
}

// ---- Hero floating solution badges (mirrors the reference's floating icon badges) ----
const HERO_BADGES = [
  { label: "Network & Security", icon: ICONS.networkSecurity, top: "6%", left: "2%" },
  { label: "Cloud", icon: ICONS.cloud, top: "2%", left: "62%" },
  { label: "Automation & AI", icon: ICONS.automation, top: "30%", left: "80%" },
  { label: "Collaboration & IoT", icon: ICONS.collaboration, top: "62%", left: "84%" },
  { label: "Datacentre", icon: ICONS.datacentre, top: "78%", left: "0%" },
  { label: "Managed Services", icon: ICONS.managed, top: "48%", left: "-4%" },
];

function HeroBadge({ label, icon, top, left }) {
  return (
    <div
      style={{
        position: "absolute",
        top,
        left,
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 8px 24px rgba(15,23,42,0.12)",
        padding: "10px 14px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "6px",
        width: "110px",
        textAlign: "center",
      }}
    >
      <Icon path={icon} size={20} />
      <span style={{ fontSize: "11px", fontWeight: 600, color: "#111827", lineHeight: 1.2 }}>{label}</span>
    </div>
  );
}

// ---- Services data (kept in sync with the detailed service boxes further down) ----
const SERVICES = [
  {
    title: "Enterprise Computing, Storage & Virtualization",
    blurb: "High-performance computing, scalable storage, and next-gen virtualization.",
    icon: ICONS.datacentre,
    details: [
      "Data Center Solutions – Rack servers, blade servers, converged and hyper-converged infrastructure.",
      "Enterprise Storage & Virtualization – SAN, NAS, NVMe, SSD storage, VMware, Hyper-V, Kubernetes.",
      "Hybrid & Cloud Computing – On-premises, private, public, and hybrid cloud deployments.",
      "High-Performance Computing (HPC) – AI/ML workloads, GPU computing, edge processing.",
    ],
  },
  {
    title: "Networking, IoT & Collaboration",
    blurb: "Seamless, intelligent, and secure connectivity with cutting-edge networking and IoT.",
    icon: ICONS.collaboration,
    details: [
      "Enterprise Networking – Switching, routing, SD-WAN, access points, network segmentation.",
      "IoT & Edge Computing – Smart sensors, industrial automation, M2M communication.",
      "Unified Communication & Collaboration – VoIP, video conferencing, Microsoft Teams, Zoom.",
      "AI-Powered Security & Surveillance – Smart monitoring, automated threat detection.",
    ],
  },
  {
    title: "Cybersecurity & Compliance",
    blurb: "Multi-layered security frameworks and proactive threat intelligence.",
    icon: ICONS.shieldCheck,
    details: [
      "Network Security & Threat Prevention – Next-Gen Firewalls (NGFW), IDS/IPS, UTM solutions.",
      "Identity & Access Management – MFA, Zero Trust, SSO.",
      "Cloud & Endpoint Protection – EDR, XDR, SIEM, SOAR solutions.",
      "Compliance & Risk Management – GDPR, ISO 27001, PCI-DSS, SOC2 compliance.",
    ],
  },
  {
    title: "Cloud, DevOps & Digital Transformation",
    blurb: "Cloud-driven IT modernization and DevOps automation for business agility.",
    icon: ICONS.cloud,
    details: [
      "Cloud Solutions – Microsoft Azure, AWS, Google Cloud, private and hybrid cloud.",
      "Cloud Migration & Automation – Terraform, Ansible, Kubernetes, Docker.",
      "AI, Big Data & Analytics – Data warehousing, Apache Hadoop, Spark, AI-driven insights.",
      "Disaster Recovery & Backup – Veeam, Acronis, Commvault, data replication & failover.",
    ],
  },
  {
    title: "Automation, AI & Analytics",
    blurb: "AI-powered automation and intelligent analytics for greater efficiency.",
    icon: ICONS.automation,
    details: [
      "AI & Machine Learning – NLP, deep learning, TensorFlow, PyTorch.",
      "Robotic Process Automation (RPA) – UiPath, Power Automate, workflow automation.",
      "Industrial IoT & Smart Infrastructure – Predictive maintenance, SCADA, IoT gateways.",
      "Business Intelligence & Data Science – Power BI, Tableau, Looker, AI dashboards.",
    ],
  },
  {
    title: "Professional & Managed Services",
    blurb: "24/7 IT efficiency with comprehensive managed services and integration support.",
    icon: ICONS.managed,
    details: [
      "End-to-End IT Support & Monitoring – IT operations, NOC, SOC.",
      "Cloud & IT Infrastructure Management – SLA-based monitoring and optimization.",
      "IT Outsourcing & Device Management – Workstations, endpoints, endpoint security.",
      "Enterprise IT Consulting & System Integration – ITSM, ITIL-based managed services.",
    ],
  },
];

// ---- Why Choose Us (generic value props — not quantitative claims) ----
const WHY_CHOOSE_US = [
  { title: "Experienced Team", desc: "Skilled professionals with deep IT infrastructure expertise.", icon: ICONS.people },
  { title: "Customer First", desc: "We prioritize your needs and deliver a responsive experience.", icon: ICONS.target },
  { title: "Innovative Solutions", desc: "Modern, cutting-edge approaches to complex IT challenges.", icon: ICONS.bulb },
  { title: "Secure & Reliable", desc: "We design for the highest standards of security and uptime.", icon: ICONS.shieldCheck },
  { title: "Dedicated Support", desc: "Support built around your business's operating hours and SLAs.", icon: ICONS.headset },
  { title: "Proven Approach", desc: "A structured, outcome-driven methodology on every engagement.", icon: ICONS.trendUp },
];

function SectionEyebrow({ children }) {
  return (
    <p
      style={{
        color: "#2563EB",
        fontSize: "12px",
        fontWeight: 700,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        textAlign: "center",
        marginBottom: "10px",
      }}
    >
      {children}
    </p>
  );
}

const Homepage = () => {
  const [showFullContent, setShowFullContent] = useState(Array(SERVICES.length).fill(false));

  const toggleService = (i) => {
    const next = [...showFullContent];
    next[i] = !next[i];
    setShowFullContent(next);
  };

  return (
    <div className="main-div" style={{ background: "#fff", color: "#111827", fontFamily: "inherit" }}>
      <style>{`
        @media (max-width: 900px) {
          .orryx-hero-grid { grid-template-columns: 1fr !important; }
          .orryx-hero-illustration { display: none !important; }
          .orryx-mv-grid { grid-template-columns: 1fr !important; }
          .orryx-services-grid { grid-template-columns: 1fr 1fr !important; }
          .orryx-why-grid { grid-template-columns: 1fr 1fr !important; }
          .orryx-stats-grid { grid-template-columns: 1fr 1fr !important; }
          .orryx-testimonial-grid { grid-template-columns: 1fr !important; }
          .orryx-footer-grid { grid-template-columns: 1fr 1fr !important; }
          .orryx-split { flex-direction: column !important; }
        }
        @media (max-width: 560px) {
          .orryx-services-grid { grid-template-columns: 1fr !important; }
          .orryx-why-grid { grid-template-columns: 1fr !important; }
          .orryx-stats-grid { grid-template-columns: 1fr !important; }
          .orryx-footer-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>

      
      {/** Slide company feature — kept as-is, your existing component */}
      <SliderPage />

      {/* ============ SERVICES ============ */}
      <section style={{ padding: "60px 40px", background: "#F3F6FC" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <SectionEyebrow>What We Do</SectionEyebrow>
          <h2 style={{ textAlign: "center", fontSize: "32px", fontWeight: 800, margin: 0, marginBottom: "8px" }}>
            Solutions That Drive Success
          </h2>
          <p style={{ textAlign: "center", color: "#6B7280", marginBottom: "40px" }}>
            ORRYX DIGITAL SOLUTION PRIVATE LIMITED — Empowers Your Business With IT Solutions
          </p>

          <div
            className="orryx-services-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "20px",
            }}
          >
            {SERVICES.map((s, i) => (
              <div
                key={s.title}
                style={{
                  background: "#fff",
                  borderRadius: "14px",
                  padding: "26px",
                  boxShadow: "0 4px 16px rgba(15,23,42,0.05)",
                }}
              >
                <div
                  style={{
                    width: "44px",
                    height: "44px",
                    borderRadius: "10px",
                    background: "#DCE6FB",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "16px",
                  }}
                >
                  <Icon path={s.icon} />
                </div>
                <h4 style={{ fontSize: "16px", fontWeight: 700, margin: 0, marginBottom: "8px" }}>{s.title}</h4>
                <p style={{ fontSize: "13.5px", color: "#6B7280", lineHeight: 1.6, margin: 0 }}>{s.blurb}</p>

                {showFullContent[i] && (
                  <ul style={{ padding: 0, margin: "14px 0 0", listStyle: "none" }}>
                    {s.details.map((d) => (
                      <li key={d} style={{ fontSize: "12.5px", color: "#4B5563", marginBottom: "6px", lineHeight: 1.5 }}>
                        ✔ {d}
                      </li>
                    ))}
                  </ul>
                )}

                <button
                  onClick={() => toggleService(i)}
                  style={{
                    marginTop: "14px",
                    background: "none",
                    border: "none",
                    color: "#2563EB",
                    fontWeight: 600,
                    fontSize: "13px",
                    cursor: "pointer",
                    padding: 0,
                  }}
                >
                  {showFullContent[i] ? "Show Less" : "Read More →"}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ SERVICE LINKS + SLIDER (existing content, restyled) ============ */}
      <section style={{ padding: "50px 40px", background: "#fff" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <ul
            style={{
              listStyleType: "none",
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              padding: 0,
              margin: "0 0 30px",
              gap: "14px",
            }}
          >
            {[
              { to: "/solution/Networking-solution", label: "Networking Solution" },
              { to: "/solution/CyberSecurity-solution", label: "CyberSecurity Solution" },
              { to: "/solution/Infastructure-solution", label: "Storage & Virtualization" },
              { to: "/solution/Cloud-solution", label: "Cloud Solution" },
              { to: "/solution/AI&LOT", label: "AI & IoT Solutions" },
            ].map((s) => (
              <li key={s.to}>
                <Link
                  to={s.to}
                  style={{
                    display: "inline-block",
                    background: "#F3F6FC",
                    color: "#1E3A8A",
                    fontWeight: 600,
                    fontSize: "13.5px",
                    padding: "12px 20px",
                    borderRadius: "8px",
                    textDecoration: "none",
                  }}
                >
                  {s.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* ============ WHY CHOOSE US ============ */}
      <section style={{ padding: "60px 40px", background: "#fff" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <SectionEyebrow>Why Choose Us</SectionEyebrow>
          <h2 style={{ textAlign: "center", fontSize: "32px", fontWeight: 800, margin: 0, marginBottom: "40px" }}>
            Your Success, Our Commitment
          </h2>

          <div
            className="orryx-why-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(6, 1fr)",
              gap: "24px",
            }}
          >
            {WHY_CHOOSE_US.map((item) => (
              <div key={item.title} style={{ textAlign: "center" }}>
                <div
                  style={{
                    width: "52px",
                    height: "52px",
                    borderRadius: "50%",
                    background: "#F3F6FC",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 14px",
                  }}
                >
                  <Icon path={item.icon} />
                </div>
                <h4 style={{ fontSize: "14.5px", fontWeight: 700, margin: 0, marginBottom: "6px" }}>{item.title}</h4>
                <p style={{ fontSize: "12.5px", color: "#6B7280", lineHeight: 1.5, margin: 0 }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ STATS BAR ============ */}
      {/* NOTE: Only "06 Solution Areas" is a verified fact from your services list.
          Replace the bracketed placeholders with real, verified figures before launch. */}
      <section style={{ background: "#0B1533", padding: "36px 40px" }}>
        <div
          className="orryx-stats-grid"
          style={{
            maxWidth: "1100px",
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "24px",
            textAlign: "center",
          }}
        >
          {[
            { num: "06", label: "Integrated Solution Areas" },
            { num: "2+", label: "Years of Experience" },
            { num: "100+", label: "Clients Served" },
            { num: "98%", label: "Client Satisfaction Rate" },
          ].map((s) => (
            <div key={s.label}>
              <div style={{ color: "#fff", fontSize: "30px", fontWeight: 800 }}>{s.num}</div>
              <div style={{ color: "#9CA9C7", fontSize: "13px", marginTop: "4px" }}>{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ============ CTA BANNER (existing "Book Your Call" content, restyled) ============ */}
      <section
        style={{
          background: "linear-gradient(90deg, #1E3A8A 0%, #2563EB 100%)",
          padding: "50px 40px",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#fff", fontSize: "28px", fontWeight: 800, margin: 0, marginBottom: "10px" }}>
          Ready to Transform Your Business?
        </h2>
        <p style={{ color: "#DCE6FB", fontSize: "15px", maxWidth: "560px", margin: "0 auto 26px", lineHeight: 1.6 }}>
          Ready to discuss your needs? Our experts are available for a free consultation — let's build the
          right solution together.
        </p>
        <Link
          to="/contact"
          style={{
            background: "#fff",
            color: "#1E3A8A",
            fontWeight: 700,
            padding: "13px 26px",
            borderRadius: "8px",
            textDecoration: "none",
            display: "inline-block",
          }}
        >
          Book Your Call →
        </Link>
      </section>

    </div>
  );
};

export default Homepage;